export const FETCH_PLAN_CANCELLATION_FEE = 'FETCH_PLAN_CANCELLATION_FEE';
export const FETCH_PLAN_CANCELLATION_FEE_DONE = 'FETCH_PLAN_CANCELLATION_FEE_DONE';
export const FETCH_PLAN_CANCELLATION_FEE_ERR = 'FETCH_PLAN_CANCELLATION_FEE_ERR';
//# sourceMappingURL=actionTypes.js.map